import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticePAndOEventComponent = (function () {
    function CasePracticePAndOEventComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.assetsRoute = "../../assets";
        this.clickDialogEnable = true;
    }
    CasePracticePAndOEventComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.characterArray = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];
        this.characterString = 'ABCDEFGH';
        this.clickable = false;
        this.teacherShow = false;
        this.instructionShow = false;
        this.infoTableShow = false;
        this.decisionShow = false;
        this.diag1Show = false;
        this.diag2Show = false;
        this.wlnPhoneShow = false;
        this.fkkPhoneShow = false;
        this.fkkContentShow = false;
        this.taskTableShow = false;
        this.urgentShow = false;
        this.urgent2Show = false;
        this.customShow = false;
        this.siteShow = false;
        this.teamShow = false;
        this.optionClick = false;
        this.optionOnClick = false;
        this.optionClickTimeout = null;
        this.cardOnSubmit1 = false;
        this.cardOnSubmit2 = false;
        this.cardOnSubmit3 = false;
        this.isActiveSortBtn = false;
        this.calculationMatrix = [
            {
                'role': '高朗',
                'experience': '3个月',
                'numberArray': [0, 0, 0, 0]
            },
            {
                'role': '方科科',
                'experience': '2年',
                'numberArray': [0, 0, 0, 0]
            },
            {
                'role': '秦飞',
                'experience': '8年',
                'numberArray': [0, 0, 0, 0]
            },
            {
                'role': '我',
                'experience': '10年',
                'numberArray': [0, 0, 0, 0]
            }
        ];
        this.customerArray = [6, 9, 1, 18];
        this.timeArray = [60, 30, 60, 15];
        this.eventHistory = [];
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/pnoQuestion/' + this.exerciseId
        }).subscribe(function (result) {
            _this.data = result;
            _this.questions = _this.data.questions;
            _this.completed = _this.data.completed;
            _this.status = result.status;
            _this.qCardShow = false;
            _this.eventHistoryInit();
            _this.eventInit();
        });
        /*this.data = this.getMockData();
        console.log(this.data);
        this.questions = this.data.questions;
        this.completed = this.data.completed;
        this.status = 55;
        this.eventHistoryInit();
        this.eventInit();*/
    };
    CasePracticePAndOEventComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        document.oncontextmenu = function (e) {
            e.preventDefault();
        };
    };
    CasePracticePAndOEventComponent.prototype.eventInit = function () {
        $('#reviewBtn').fadeIn(200);
        // console.log(this.status);
        // console.log("this status is" + this.status.toString());
        var _this = this;
        if (this.status == 15) {
            this.clickable = false;
            this.questionIndex = 0;
            this.currentQuestion = this.questions[this.questionIndex];
            this.currentQuestionTitle = this.currentQuestion.title[0];
            this.optionSelectedIndex = -1;
            this.showId = 1;
            this.eventHistory.push({
                'role': '问题1',
                'comment': this.currentQuestionTitle,
                'type': 1
            });
            setTimeout(function () {
                _this.qCardShow = true;
            }, 1000);
        }
        else if (this.status == 20) {
            this.questionIndex = 1;
            this.currentQuestion = this.questions[this.questionIndex];
            this.optionSelectedIndex = -1;
            if (this.completed[0].answer == 'A') {
                this.currentQuestionTitle = this.currentQuestion.title[0].split(':')[1];
                this.setSortOptionsInitial();
                this.instruction = this.currentQuestion.task_list[0].split(':')[1];
                this.step = 108;
                this.showId = 2;
                setTimeout(function () {
                    _this.instructionShow = true;
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else {
                this.clickable = false;
                this.currentQuestionTitle = this.currentQuestion.title[1].split(':')[1];
                this.setSortOptionsInitial();
                this.step = 103;
                this.showId = 1;
                setTimeout(function () {
                    _this.qCardShow = true;
                }, 1000);
            }
        }
        else if (this.status == 25) {
            this.questionIndex = 2;
            this.currentQuestion = this.questions[this.questionIndex];
            this.optionSelectedIndex = -1;
            this.step = 201;
            if (this.completed[1].answer == 1234 || this.completed[1].answer == 1324) {
                this.instruction = this.currentQuestion.task_list[0].split(':')[1];
            }
            else {
                this.instruction = this.currentQuestion.task_list[1].split(':')[1];
            }
            this.showId = 2;
            setTimeout(function () {
                _this.instructionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.status == 30) {
            this.questionIndex = 2;
            this.currentQuestion = this.questions[this.questionIndex];
            if (this.completed[2].answer == 'D') {
                this.instruction = this.currentQuestion.task_list[5].split('方科科:')[0].split(':')[1];
                this.showId = 2;
                this.step = 209;
                setTimeout(function () {
                    _this.instructionShow = true;
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else {
                if (this.completed[2].answer == 'C') {
                    this.currentShortConversation = this.currentQuestion.task_list[4].split(':')[2];
                }
                else {
                    this.currentShortConversation = this.currentQuestion.task_list[3].split(':')[2];
                }
                this.showId = 3;
                this.step = 207;
                setTimeout(function () {
                    _this.wlnPhoneShow = true;
                    _this.diag1Show = true;
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 2000);
                }, 1000);
            }
        }
        else if (this.status == 35) {
            this.questionIndex = 3;
            this.currentQuestion = this.questions[this.questionIndex];
            if (this.completed[3].answer == 'A') {
                this.currentShortConversationIndex = 1;
                this.currentShortConversation = this.currentQuestion.task_list[1].split('/')[0].split(':')[2];
                this.step = 304;
            }
            else {
                this.currentShortConversation = this.currentQuestion.task_list[2].split(':')[2];
                this.step = 307;
            }
            this.showId = 4;
            setTimeout(function () {
                _this.clickable = true;
            }, 1000);
            /*setTimeout(function(){
      
              _this.qCardShow = true;
              _this.clickable = false;
      
            }, 250);*/
        }
        else if (this.status == 40) {
            this.questionIndex = 5;
            this.currentQuestion = this.questions[this.questionIndex];
            if (this.completed[4].answer == 'B') {
                /*this.calculationMatrix.pop();*/
                this.meSelected = false;
            }
            else {
                this.meSelected = true;
            }
            this.showId = 5;
            this.step = 501;
            this.clickable = false;
        }
        else if (this.status == 45) {
            this.questionIndex = 6;
            this.currentQuestion = this.questions[this.questionIndex];
            this.instruction = this.currentQuestion.title[0];
            this.step = 601;
            this.showId = 2;
            setTimeout(function () {
                _this.instructionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.status == 50) {
            this.questionIndex = 6;
            this.currentQuestion = this.questions[this.questionIndex];
            var temp_1 = this.completed[6].answer;
            this.currentQuestion.task_list.forEach(function (item, index) {
                if (item.indexOf(temp_1) != -1) {
                    _this.instruction = item.split(':')[1];
                }
            });
            this.showId = 2;
            this.step = 605;
            setTimeout(function () {
                _this.instructionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.status == 55) {
            this.questionIndex = 7;
            this.currentQuestion = this.questions[this.questionIndex];
            this.instruction = this.currentQuestion.task_list[0];
            this.showId = 2;
            this.step = 703;
            this.reportBtnShow = true;
            this.qCardShow = false;
            setTimeout(function () {
                _this.instructionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        /*this.setHeight();*/
    };
    CasePracticePAndOEventComponent.prototype.eventHistoryInit = function () {
        this.eventHistory15();
        if (!this.userType) {
            if (this.status == 20) {
                this.eventHistory20();
            }
            else if (this.status == 25) {
                this.eventHistory20();
                this.eventHistory25();
            }
            else if (this.status == 30) {
                this.eventHistory20();
                this.eventHistory25();
                this.eventHistory30();
            }
            else if (this.status == 35) {
                this.eventHistory20();
                this.eventHistory25();
                this.eventHistory30();
                this.eventHistory35();
            }
            else if (this.status == 40) {
                this.eventHistory20();
                this.eventHistory25();
                this.eventHistory30();
                this.eventHistory35();
                this.eventHistory40();
            }
            else if (this.status == 45) {
                this.eventHistory20();
                this.eventHistory25();
                this.eventHistory30();
                this.eventHistory35();
                this.eventHistory40();
                this.eventHistory45();
            }
            else if (this.status == 50) {
                this.eventHistory20();
                this.eventHistory25();
                this.eventHistory30();
                this.eventHistory35();
                this.eventHistory40();
                this.eventHistory45();
                this.eventHistory50();
            }
            else if (this.status == 55) {
                this.eventHistory20();
                this.eventHistory25();
                this.eventHistory30();
                this.eventHistory35();
                this.eventHistory40();
                this.eventHistory45();
                this.eventHistory50();
                this.eventHistory55();
            }
        }
    };
    CasePracticePAndOEventComponent.prototype.eventHistory15 = function () {
        var that = this;
        this.eventHistory.push({
            'role': '任务详情',
            'comment': that.questions[0].task_list[5] + '<br/><br/>' + that.questions[0].task_list[6] + that.questions[0].task_list[7] + that.questions[0].task_list[8] + that.questions[0].task_list[9],
            'type': 9,
            'mode': 0
        }, {
            'role': '时间表',
            'comment': that.questions[0].task_list[10],
            'type': 9,
            'mode': 0
        });
    };
    CasePracticePAndOEventComponent.prototype.eventHistory20 = function () {
        var that = this;
        var answer = that.completed[0].answer;
        var optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
        var analysis;
        this.questions[0].director_comment.forEach(function (item, index) {
            if (item.indexOf(answer) != -1) {
                analysis = item.split(':')[1];
            }
        });
        this.eventHistory.push({
            'role': '问题1',
            'comment': that.questions[0].title[0],
            'type': 1
        }, {
            'role': '你的答案',
            'comment': that.questions[0].options[optionIndex],
            'type': 4
        }, {
            'role': '导师点评',
            'comment': analysis,
            'type': 5
        });
        if (answer == 'A') {
            this.eventHistory.push({
                'role': '情节',
                'comment': that.questions[1].task_list[0],
                'type': 2
            });
        }
        else {
            this.eventHistory.push({
                'role': '排序题',
                'comment': that.questions[1].title[1].split(':')[1],
                'type': 1
            });
        }
    };
    CasePracticePAndOEventComponent.prototype.eventHistory25 = function () {
        var that = this;
        var lastQuestionAnswer = that.completed[0].answer;
        if (lastQuestionAnswer == 'A') {
            this.eventHistory.push({
                'role': '信息表',
                'comment': that.questions[1].task_list[1].split(':')[1],
                'type': 9,
                'mode': 0
            }, {
                'role': '排序题',
                'comment': that.questions[1].title[0].split(':')[1],
                'type': 1
            });
        }
        var answerNumber = this.completed[1].answer;
        var answerArray = [];
        for (var i = 0; i < 4; i++) {
            answerArray.push(this.questions[1].options[parseInt(answerNumber[i]) - 1]);
        }
        var currentComment;
        if (answerNumber == 1234 || answerNumber == 1324) {
            currentComment = that.questions[2].task_list[0].split(':')[1];
        }
        else {
            currentComment = that.questions[2].task_list[1].split(':')[1];
        }
        this.eventHistory.push({
            'role': '你的答案',
            'comment': answerArray,
            'type': 4
        }, {
            'role': '导师点评',
            'comment': that.questions[1].director_comment,
            'type': 5
        }, {
            'role': '情节',
            'comment': currentComment,
            'type': 2
        });
    };
    CasePracticePAndOEventComponent.prototype.eventHistory30 = function () {
        var that = this;
        this.eventHistory.push({
            'role': '决定',
            'comment': that.questions[2].task_list[2],
            'type': 9,
            'mode': 0
        }, {
            'role': '情节',
            'comment': that.questions[2].title[0],
            'type': 2
        });
        var temp = this.questions[2].title[1].split('/');
        temp.forEach(function (item) {
            that.eventHistory.push({
                'role': item.split(':')[0],
                'comment': item.split(':')[1],
                'type': 3
            });
        });
        var answer = that.completed[2].answer;
        var optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
        this.eventHistory.push({
            'role': '你的答案',
            'comment': that.questions[2].options[optionIndex],
            'type': 4
        }, {
            'role': '导师点评',
            'comment': that.questions[2].director_comment[0],
            'type': 5
        });
        if (answer == 'A' || answer == 'B') {
            this.eventHistory.push({
                'role': '王丽娜',
                'comment': that.questions[2].task_list[3].split(':')[2],
                'type': 3
            });
        }
        else if (answer == 'C') {
            this.eventHistory.push({
                'role': '王丽娜',
                'comment': that.questions[2].task_list[4].split(':')[2],
                'type': 3
            });
        }
        else {
            this.eventHistory.push({
                'role': '情节',
                'comment': that.questions[2].task_list[5].split('方科科:')[0].split(':')[1],
                'type': 2
            });
        }
    };
    CasePracticePAndOEventComponent.prototype.eventHistory35 = function () {
        var that = this;
        var lastQuestionAnswer = this.completed[2].answer;
        if (lastQuestionAnswer == 'D') {
            this.eventHistory.push({
                'role': '方科科',
                'comment': that.questions[2].task_list[5].split('方科科:')[1],
                'type': 3
            });
        }
        var answer = this.completed[3].answer;
        var optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
        var analysis;
        this.questions[3].director_comment.forEach(function (item, index) {
            if (item.indexOf(answer) != -1) {
                analysis = item.split(':')[1];
            }
        });
        var myWord;
        if (answer == 'A') {
            myWord = this.questions[3].task_list[1].split('/')[0].split(':')[2];
        }
        else {
            myWord = this.questions[3].task_list[2].split(':')[2];
        }
        this.eventHistory.push({
            'role': '情节',
            'comment': that.questions[2].task_list[6],
            'type': 2
        }, {
            'role': '任务表',
            'comment': that.questions[3].task_list[0],
            'type': 9,
            'mode': 0
        }, {
            'role': '问题',
            'comment': that.questions[3].title[0],
            'type': 1
        }, {
            'role': '你的答案',
            'comment': that.questions[3].options[optionIndex],
            'type': 4
        }, {
            'role': '导师点评',
            'comment': analysis,
            'type': 5
        }, {
            'role': '我',
            'comment': myWord,
            'type': 3
        });
    };
    CasePracticePAndOEventComponent.prototype.eventHistory40 = function () {
        var that = this;
        var lastQuestionAnswer = this.completed[3].answer;
        if (lastQuestionAnswer == 'A') {
            this.eventHistory.push({
                'role': '秦飞',
                'comment': that.questions[3].task_list[1].split('/')[1].split(':')[1],
                'type': 3
            }, {
                'role': '我',
                'comment': that.questions[3].task_list[1].split('/')[2].split(':')[1],
                'type': 3
            });
        }
        var answer = this.completed[4].answer;
        var optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
        var analysis;
        this.questions[4].director_comment.forEach(function (item, index) {
            if (item.indexOf(answer) != -1) {
                analysis = item.split(':')[1];
            }
        });
        this.eventHistory.push({
            'role': '情节',
            'comment': that.questions[4].task_list[0],
            'type': 2
        }, {
            'role': '客户信息',
            'comment': that.questions[5].title[0],
            'type': 9,
            'mode': 0
        }, {
            'role': '场地信息',
            'comment': that.questions[5].title[1] + that.questions[5].title[2],
            'type': 9,
            'mode': 0
        }, {
            'role': '团队信息',
            'comment': that.questions[5].title[3],
            'type': 9,
            'mode': 0
        }, {
            'role': '情节',
            'comment': '秦飞因为水土不服，到了旧金山就上吐下泻，身体很虚弱。',
            'type': 2
        }, {
            'role': '问题',
            'comment': that.questions[4].title[0],
            'type': 1
        }, {
            'role': '你的答案',
            'comment': that.questions[4].options[optionIndex],
            'type': 4
        }, {
            'role': '导师点评',
            'comment': analysis,
            'type': 5
        });
    };
    CasePracticePAndOEventComponent.prototype.eventHistory45 = function () {
        var that = this;
        this.eventHistory.push({
            'role': '情节',
            'comment': that.questions[6].title[0],
            'type': 2
        });
    };
    CasePracticePAndOEventComponent.prototype.eventHistory50 = function () {
        var that = this;
        var answer = this.completed[6].answer;
        var optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
        var commentCurrent;
        this.questions[6].task_list.forEach(function (item, index) {
            if (item.indexOf(answer) != -1) {
                commentCurrent = item.split(':')[1];
            }
        });
        this.eventHistory.push({
            'role': '方科科',
            'comment': that.questions[6].title[1].split(':')[1],
            'type': 3
        }, {
            'role': '你的答案',
            'comment': that.questions[6].options[optionIndex],
            'type': 4
        }, {
            'role': '导师点评',
            'comment': that.questions[6].director_comment[0],
            'type': 5
        }, {
            'role': '情节',
            'comment': commentCurrent,
            'type': 2
        });
    };
    CasePracticePAndOEventComponent.prototype.eventHistory55 = function () {
        var that = this;
        var answer = this.completed[7].answer;
        var optionIndex = answer.charCodeAt(0) - 'A'.charCodeAt(0);
        this.eventHistory.push({
            'role': '问题',
            'comment': that.questions[7].title[0],
            'type': 1
        }, {
            'role': '你的答案',
            'comment': that.questions[7].options[optionIndex],
            'type': 4
        }, {
            'role': '导师点评',
            'comment': that.questions[7].director_comment[0],
            'type': 5
        }, {
            'role': '情节',
            'comment': that.questions[7].task_list[0],
            'type': 2
        });
    };
    CasePracticePAndOEventComponent.prototype.screenClick = function () {
        var _this = this;
        // console.log("step is" + this.step.toString());
        // console.log(this.clickable);
        if (!this.clickable) {
            return;
        }
        //回顾修改
        if (!this.clickDialogEnable) {
            return false;
        }
        // console.log(this.step);
        if (this.step == 101) {
            var temp_2 = this.characterArray[this.oldOptionSelectedIndex];
            var tempQuestion = void 0;
            this.clickable = false;
            this.step = 108;
            this.oldQuestionIndex = this.questionIndex;
            this.oldOptionSelectedIndex = this.optionSelectedIndex;
            if (this.questionIndex == 4) {
                this.questionIndex += 2;
            }
            else {
                this.questionIndex++;
            }
            this.optionSelectedIndex = -1;
            tempQuestion = this.questions[this.questionIndex];
            this.currentQuestion = tempQuestion;
            tempQuestion.title.forEach(function (item, index) {
                if (item.indexOf(temp_2) != -1) {
                    _this.currentQuestionTitle = item.split(':')[1];
                }
            });
            this.setSortOptionsInitial();
            this.instruction = this.currentQuestion.task_list[0].split(':')[1];
            $('#teacherPic').fadeOut(200);
            this.teacherShow = false;
            setTimeout(function () {
                _this.instructionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
            this.eventHistory.push({
                'role': '情节',
                'comment': this.instruction,
                'type': 2
            });
        }
        else if (this.step == 102) {
            var temp_3 = this.characterArray[this.oldOptionSelectedIndex];
            var tempQuestion = void 0;
            this.clickable = false;
            this.step = 103;
            this.oldQuestionIndex = this.questionIndex;
            this.oldOptionSelectedIndex = this.optionSelectedIndex;
            if (this.questionIndex == 4) {
                this.questionIndex += 2;
            }
            else {
                this.questionIndex++;
            }
            this.optionSelectedIndex = -1;
            tempQuestion = this.questions[this.questionIndex];
            this.currentQuestion = tempQuestion;
            tempQuestion.title.forEach(function (item, index) {
                if (item.indexOf(temp_3) != -1) {
                    _this.currentQuestionTitle = item.split(':')[1];
                }
            });
            this.setSortOptionsInitial();
            $('#teacherPic').fadeOut(200);
            this.teacherShow = false;
            setTimeout(function () {
                _this.qCardShow = true;
            }, 1000);
            this.eventHistory.push({
                'role': '问题',
                'comment': this.currentQuestionTitle,
                'type': 1
            });
        }
        else if (this.step == 108) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 109;
            this.instructionShow = false;
            setTimeout(function () {
                _this.infoTableShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
            this.eventHistory.push({
                'role': '信息表',
                'comment': tempQuestion.task_list[1],
                'type': 9,
                'mode': 0
            });
        }
        else if (this.step == 109) {
            this.clickable = false;
            this.step = 103;
            this.infoTableShow = false;
            setTimeout(function () {
                _this.qCardShow = true;
                // _this.clickable = false;
            }, 1000);
            this.eventHistory.push({
                'role': '问题',
                'comment': this.currentQuestionTitle,
                'type': 1
            });
        }
        else if (this.step == 104) {
            var tempQuestion = void 0;
            this.clickable = false;
            this.step = 201;
            this.oldQuestionIndex = this.questionIndex;
            this.oldOptionSelectedIndex = this.optionSelectedIndex;
            if (this.questionIndex == 4) {
                this.questionIndex += 2;
            }
            else {
                this.questionIndex++;
            }
            this.optionSelectedIndex = -1;
            tempQuestion = this.questions[this.questionIndex];
            this.currentQuestion = tempQuestion;
            if (this.sortQuestionsAnswer == 1234 || this.sortQuestionsAnswer == 1324) {
                this.instruction = tempQuestion.task_list[0].split(':')[1];
            }
            else {
                this.instruction = tempQuestion.task_list[1].split(':')[1];
            }
            $('#teacherPic').fadeOut(200);
            this.teacherShow = false;
            this.eventHistory.push({
                'role': '情节',
                'comment': this.instruction,
                'type': 2
            });
            setTimeout(function () {
                _this.instructionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.step == 201) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 202;
            this.instructionShow = false;
            setTimeout(function () {
                _this.decisionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
            this.eventHistory.push({
                'role': '决定',
                'comment': tempQuestion.task_list[2],
                'type': 9,
                'mode': 0
            });
        }
        else if (this.step == 202) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 203;
            this.decisionShow = false;
            this.instruction = tempQuestion.title[0];
            var temp = tempQuestion.title[1].split('/');
            this.shortConversation = [];
            temp.forEach(function (item, index) {
                _this.shortConversation.push({
                    'role': item.split(':')[0],
                    'comment': item.split(':')[1]
                });
            });
            this.currentShortConversationIndex = 0;
            setTimeout(function () {
                _this.instructionShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
            this.eventHistory.push({
                'role': '情节',
                'comment': this.instruction,
                'type': 2
            });
        }
        else if (this.step == 203) {
            this.clickable = false;
            if (this.userType) {
                $("#shade2").fadeIn();
                $('#tip2').fadeIn();
            }
            else {
                if (this.currentShortConversationIndex == 0) {
                    this.instructionShow = false;
                    setTimeout(function () {
                        _this.wlnPhoneShow = true;
                        setTimeout(function () {
                            _this.diag1Show = true;
                            _this.currentShortConversation = _this.shortConversation[_this.currentShortConversationIndex].comment;
                            _this.currentShortConversationIndex++;
                            _this.eventHistory.push({
                                'role': '王立娜',
                                'comment': _this.currentShortConversation,
                                'type': 3
                            });
                            setTimeout(function () {
                                _this.clickable = true;
                            }, 1500);
                        }, 2000);
                    }, 1000);
                }
                else if (this.currentShortConversationIndex == 2) {
                    this.diag2Show = false;
                    setTimeout(function () {
                        _this.currentShortConversation = _this.shortConversation[_this.currentShortConversationIndex].comment;
                        _this.diag1Show = true;
                        _this.step = 204;
                        _this.eventHistory.push({
                            'role': '王立娜',
                            'comment': _this.currentShortConversation,
                            'type': 3
                        });
                        setTimeout(function () {
                            _this.clickable = true;
                        }, 800);
                    }, 800);
                }
                else if (this.currentShortConversationIndex == 1) {
                    this.diag1Show = false;
                    setTimeout(function () {
                        _this.currentShortConversation = _this.shortConversation[_this.currentShortConversationIndex].comment;
                        _this.diag2Show = true;
                        _this.currentShortConversationIndex++;
                        _this.eventHistory.push({
                            'role': '我',
                            'comment': _this.currentShortConversation,
                            'type': 3
                        });
                        setTimeout(function () {
                            _this.clickable = true;
                        }, 800);
                    }, 800);
                }
            }
        }
        else if (this.step == 204) {
            this.clickable = false;
            this.step = 205;
            // this.wlnPhoneShow = false;
            $('#wlnTelephone').fadeOut(200);
            this.diag1Show = false;
            setTimeout(function () {
                $('#optionsWrap2').fadeIn(200);
                // setTimeout(function(){
                //   _this.clickable = true;
                // }, 650);
            }, 1000);
        }
        else if (this.step == 206) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            if (this.optionSelectedIndex == 3) {
                $('#teacherPic').fadeOut(200);
                this.teacherShow = false;
                this.instruction = tempQuestion.task_list[5].split('方科科:')[0].split(':')[1];
                setTimeout(function () {
                    _this.instructionShow = true;
                    _this.step = 209;
                    _this.eventHistory.push({
                        'role': '情节',
                        'comment': _this.instruction,
                        'type': 2
                    });
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else {
                if (this.optionSelectedIndex == 2) {
                    this.currentShortConversation = tempQuestion.task_list[4].split(':')[2];
                }
                else {
                    this.currentShortConversation = tempQuestion.task_list[3].split(':')[2];
                }
                $('#teacherPic').fadeOut(200);
                this.teacherShow = false;
                setTimeout(function () {
                    // _this.wlnPhoneShow = true;
                    $('#wlnTelephone').fadeIn(200);
                    setTimeout(function () {
                        _this.diag1Show = true;
                        _this.step = 207;
                        _this.eventHistory.push({
                            'role': '王立娜',
                            'comment': _this.currentShortConversation,
                            'type': 3
                        });
                        setTimeout(function () {
                            _this.clickable = true;
                        }, 1000);
                    }, 1000);
                }, 1000);
            }
        }
        else if (this.step == 207) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            $('#wlnTelephone').fadeOut(200);
            this.diag1Show = false;
            this.instruction = tempQuestion.task_list[6];
            setTimeout(function () {
                _this.instructionShow = true;
                _this.step = 208;
                _this.eventHistory.push({
                    'role': '情节',
                    'comment': _this.instruction,
                    'type': 2
                });
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
                $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg4.png")');
            }, 800);
        }
        else if (this.step == 208) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 301;
            this.instructionShow = false;
            this.currentQuestionTitle = tempQuestion.title[0];
            setTimeout(function () {
                _this.taskTableShow = true;
                _this.resetQuestion();
                _this.eventHistory.push({
                    'role': '任务表',
                    'comment': _this.questions[3].task_list[0],
                    'type': 9,
                    'mode': 0
                });
                // setTimeout(function(){
                //   _this.clickable = true;
                // }, 1000);
            }, 1000);
        }
        else if (this.step == 209) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 210;
            this.instructionShow = false;
            this.currentShortConversation = tempQuestion.task_list[5].split('方科科:')[1];
            setTimeout(function () {
                $('#fkk2').fadeIn(200);
                _this.fkkContentShow = true;
                _this.eventHistory.push({
                    'role': '方科科',
                    'comment': _this.currentShortConversation,
                    'type': 3
                });
                setTimeout(function () {
                    _this.clickable = true;
                }, 800);
            }, 1000);
        }
        else if (this.step == 210) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            $('#fkk2').fadeOut(200);
            this.fkkContentShow = false;
            this.instruction = tempQuestion.task_list[6];
            setTimeout(function () {
                _this.instructionShow = true;
                _this.step = 208;
                _this.eventHistory.push({
                    'role': '情节',
                    'comment': _this.instruction,
                    'type': 2
                });
                $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg4.png")');
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 800);
        }
        else if (this.step == 301) {
            this.clickable = false;
            this.step = 303;
            this.taskTableShow = false;
            setTimeout(function () {
                _this.urgentShow = true;
                setTimeout(function () {
                    $("#boo").fadeIn(10);
                    $("#urgentText").fadeIn(200);
                    setTimeout(function () {
                        this.urgentShow = false;
                        $("#urgent").fadeOut(200);
                        $("#boo").fadeOut(200);
                        $("#urgentText").fadeOut(200);
                        setTimeout(function () {
                            _this.qCardShow = true;
                            // _this.clickable = false;
                            _this.urgent2Show = true;
                            _this.eventHistory.push({
                                'role': '问题',
                                'comment': _this.currentQuestionTitle,
                                'type': 1
                            });
                        }, 350);
                    }, 1150);
                }, 250);
            }, 1000);
        }
        else if (this.step == 302) {
            this.clickable = false;
            this.step = 303;
            this.urgentShow = false;
            $("#boo").fadeOut(200);
            $("#urgentText").fadeOut(200);
            setTimeout(function () {
                _this.qCardShow = true;
                // _this.clickable = false;
                _this.eventHistory.push({
                    'role': '问题',
                    'comment': _this.currentQuestionTitle,
                    'type': 1
                });
            }, 800);
        }
        else if (this.step == 304) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            if (this.currentShortConversationIndex == 0) {
                $('#teacherPic').fadeOut(200);
                this.teacherShow = false;
                this.currentShortConversation = tempQuestion.task_list[1].split('/')[0].split(':')[2];
                setTimeout(function () {
                    $('#gl').fadeIn(200);
                    /*$('#wln').fadeIn(200);*/
                    $('#fkk').fadeIn(200);
                    $('#qf').fadeIn(200);
                    $('#dialogueBox3').fadeIn(200);
                    _this.currentShortConversationIndex++;
                    _this.eventHistory.push({
                        'role': '我',
                        'comment': _this.currentShortConversation,
                        'type': 3
                    });
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else if (this.currentShortConversationIndex == 1) {
                $('#gl').fadeOut(200);
                /*$('#wln').fadeOut(200);*/
                $('#fkk').fadeOut(200);
                $('#qf').fadeOut(200);
                $('#dialogueBox3').fadeOut(200);
                this.currentShortConversation = tempQuestion.task_list[1].split('/')[1].split(':')[1];
                setTimeout(function () {
                    _this.showQFDialog();
                    _this.currentShortConversationIndex++;
                    _this.eventHistory.push({
                        'role': '秦飞',
                        'comment': _this.currentShortConversation,
                        'type': 3
                    });
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
            else if (this.currentShortConversationIndex == 2) {
                this.hideQFDialog();
                this.currentShortConversation = tempQuestion.task_list[1].split('/')[2].split(':')[1];
                setTimeout(function () {
                    $('#dialogueBox3').fadeIn(200);
                    _this.currentShortConversationIndex++;
                    _this.step = 306;
                    _this.eventHistory.push({
                        'role': '我',
                        'comment': _this.currentShortConversation,
                        'type': 3
                    });
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 1000);
            }
        }
        else if (this.step == 305) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 307;
            $('#teacherPic').fadeOut(200);
            this.teacherShow = false;
            this.currentShortConversation = tempQuestion.task_list[2].split(':')[2];
            this.eventHistory.push({
                'role': '我',
                'comment': this.currentShortConversation,
                'type': 3
            });
            setTimeout(function () {
                $('#gl').fadeIn(200);
                /*$('#wln').fadeIn(200);*/
                $('#fkk').fadeIn(200);
                $('#qf').fadeIn(200);
                $('#dialogueBox3').fadeIn(200);
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.step == 306) {
            var tempQuestion = void 0;
            this.clickable = false;
            this.step = 401;
            this.oldQuestionIndex = this.questionIndex;
            this.oldOptionSelectedIndex = this.optionSelectedIndex;
            if (this.questionIndex == 4) {
                this.questionIndex += 2;
            }
            else {
                this.questionIndex++;
            }
            this.optionSelectedIndex = -1;
            tempQuestion = this.questions[this.questionIndex];
            this.currentQuestion = tempQuestion;
            $('#dialogueBox3').fadeOut(200);
            $('#qf2').fadeOut(200);
            this.instruction = tempQuestion.task_list[0];
            setTimeout(function () {
                _this.instructionShow = true;
                $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg3.png")');
                _this.eventHistory.push({
                    'role': '情节',
                    'comment': _this.instruction,
                    'type': 2
                });
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 800);
        }
        else if (this.step == 307) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 401;
            this.oldQuestionIndex = this.questionIndex;
            this.oldOptionSelectedIndex = this.optionSelectedIndex;
            if (this.questionIndex == 4) {
                this.questionIndex += 2;
            }
            else {
                this.questionIndex++;
            }
            this.optionSelectedIndex = -1;
            tempQuestion = this.questions[this.questionIndex];
            this.currentQuestion = tempQuestion;
            $('#dialogueBox3').fadeOut(200);
            $('#gl').fadeOut(200);
            /*$('#wln').fadeOut(200);*/
            $('#fkk').fadeOut(200);
            $('#qf').fadeOut(200);
            this.instruction = tempQuestion.task_list[0];
            this.eventHistory.push({
                'role': '情节',
                'comment': this.instruction,
                'type': 2
            });
            setTimeout(function () {
                _this.instructionShow = true;
                $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg3.png")');
                setTimeout(function () {
                    _this.clickable = true;
                }, 1200);
            }, 1000);
        }
        else if (this.step == 401) {
            this.clickable = false;
            this.step = 402;
            this.instructionShow = false;
            this.eventHistory.push({
                'role': '客户信息',
                'comment': this.questions[5].title[0],
                'type': 9,
                'mode': 0
            });
            setTimeout(function () {
                _this.customShow = true;
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.step == 402) {
            this.clickable = false;
            this.step = 403;
            this.customShow = false;
            setTimeout(function () {
                _this.siteShow = true;
                _this.eventHistory.push({
                    'role': '场地信息',
                    'comment': _this.questions[5].title[1] + _this.questions[5].title[2],
                    'type': 9,
                    'mode': 0
                });
                setTimeout(function () {
                    _this.clickable = true;
                }, 1500);
            }, 1000);
        }
        else if (this.step == 403) {
            this.clickable = false;
            this.step = 404;
            this.siteShow = false;
            setTimeout(function () {
                _this.teamShow = true;
                _this.eventHistory.push({
                    'role': '团队信息',
                    'comment': _this.questions[5].title[3],
                    'type': 9,
                    'mode': 0
                });
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.step == 404) {
            this.clickable = false;
            this.step = 405;
            this.teamShow = false;
            setTimeout(function () {
                _this.instruction = '秦飞因为水土不服，到了旧金山就上吐下泻，身体很虚弱。';
                _this.instructionShow = true;
                _this.eventHistory.push({
                    'role': '情节',
                    'comment': _this.instruction,
                    'type': 2
                });
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 1000);
        }
        else if (this.step == 405) {
            this.clickable = false;
            var tempQuestion = this.currentQuestion;
            this.step = 406;
            this.instructionShow = false;
            this.currentQuestionTitle = tempQuestion.title[0];
            setTimeout(function () {
                _this.qCardShow = true;
                // _this.clickable = false;
                _this.eventHistory.push({
                    'role': '题目',
                    'comment': _this.currentQuestionTitle,
                    'type': 1
                });
            }, 1000);
        }
        else if (this.step == 407) {
            this.clickable = false;
            this.step = 501;
            $('#teacherPic').fadeOut(200);
            this.teacherShow = false;
            $('#reviewBtn').fadeOut(200);
            setTimeout(function () {
                $('#calculationWrap').fadeIn(200);
            }, 1000);
        }
        else if (this.step == 601) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 602;
            this.instructionShow = false;
            this.currentShortConversation = tempQuestion.title[1].split(':')[1];
            setTimeout(function () {
                _this.fkkPhoneShow = true;
                setTimeout(function () {
                    _this.diag1Show = true;
                    _this.eventHistory.push({
                        'role': '方科科',
                        'comment': _this.currentShortConversation,
                        'type': 3
                    });
                    setTimeout(function () {
                        _this.clickable = true;
                    }, 1000);
                }, 2000);
            }, 1000);
        }
        else if (this.step == 602) {
            this.clickable = false;
            this.step = 603;
            this.fkkPhoneShow = false;
            this.diag1Show = false;
            setTimeout(function () {
                $('#optionsWrap2').fadeIn(200);
            }, 1000);
        }
        else if (this.step == 604) {
            var tempQuestion_1 = this.currentQuestion;
            this.clickable = false;
            this.step = 605;
            $('#teacherPic').fadeOut(200);
            this.teacherShow = false;
            setTimeout(function () {
                var temp = _this.characterArray[_this.optionSelectedIndex];
                tempQuestion_1.task_list.forEach(function (item, index) {
                    if (item.indexOf(temp) != -1) {
                        _this.instruction = item.split(':')[1];
                    }
                });
                _this.instructionShow = true;
                _this.eventHistory.push({
                    'role': '情节',
                    'comment': _this.instruction,
                    'type': 2
                });
                setTimeout(function () {
                    _this.clickable = true;
                }, 1000);
            }, 800);
        }
        else if (this.step == 605) {
            var tempQuestion = void 0;
            this.clickable = false;
            this.step = 701;
            this.instructionShow = false;
            this.oldQuestionIndex = this.questionIndex;
            this.oldOptionSelectedIndex = this.optionSelectedIndex;
            if (this.questionIndex == 4) {
                this.questionIndex += 2;
            }
            else {
                this.questionIndex++;
            }
            this.optionSelectedIndex = -1;
            tempQuestion = this.questions[this.questionIndex];
            this.currentQuestion = tempQuestion;
            this.currentQuestionTitle = tempQuestion.title[0];
            setTimeout(function () {
                // _this.clickable = false;
                _this.qCardShow = true;
                _this.eventHistory.push({
                    'role': '题目',
                    'comment': _this.currentQuestionTitle,
                    'type': 1
                });
            }, 1000);
        }
        else if (this.step == 702) {
            var tempQuestion = this.currentQuestion;
            this.clickable = false;
            this.step = 703;
            $('#teacherPic').fadeOut(200);
            this.teacherShow = false;
            this.instruction = tempQuestion.task_list[0];
            setTimeout(function () {
                _this.instructionShow = true;
                $('#reportBtn').fadeIn(200);
                $('#wrap').css('background-image', 'url("../../assets/picture/casepracticepando/bg2.png")');
                _this.eventHistory.push({
                    'role': '情节',
                    'comment': _this.instruction,
                    'type': 2
                });
                setTimeout(function () {
                    _this.clickable = false;
                }, 1000);
            }, 1000);
        }
    };
    CasePracticePAndOEventComponent.prototype.onOptionClick = function ($event, i) {
        $event.stopPropagation();
        this.optionSelectedIndex = i;
    };
    CasePracticePAndOEventComponent.prototype.resetQuestion = function () {
        var _this = this;
        this.oldQuestionIndex = this.questionIndex;
        this.oldOptionSelectedIndex = this.optionSelectedIndex;
        if (this.questionIndex == 4) {
            this.questionIndex += 2;
        }
        else {
            this.questionIndex++;
        }
        this.optionSelectedIndex = -1;
        this.currentQuestion = this.questions[this.questionIndex];
        this.currentQuestionTitle = this.currentQuestion.title[0];
        setTimeout(function () {
            _this.clickable = true;
        }, 500);
    };
    CasePracticePAndOEventComponent.prototype.arrowDownClick = function (i) {
        var temp = this.currentQuestion.options[i];
        var tempNext = this.currentQuestion.options[i + 1];
        this.currentQuestion.options[i] = tempNext;
        this.currentQuestion.options[i + 1] = temp;
    };
    CasePracticePAndOEventComponent.prototype.arrowUpClick = function (i) {
        var temp = this.currentQuestion.options[i];
        var tempPrevious = this.currentQuestion.options[i - 1];
        this.currentQuestion.options[i] = tempPrevious;
        this.currentQuestion.options[i - 1] = temp;
    };
    CasePracticePAndOEventComponent.prototype.setSortOptionsInitial = function () {
        var _this = this;
        this.sortOptionsInitial = [];
        this.currentQuestion.options.forEach(function (item, index) {
            _this.sortOptionsInitial.push({
                'id': index + 1,
                'option': item
            });
        });
        this.currentQuestion.options = [this.sortOptionsInitial[1].option, this.sortOptionsInitial[0].option, this.sortOptionsInitial[3].option, this.sortOptionsInitial[2].option];
    };
    CasePracticePAndOEventComponent.prototype.getSortOptionIdByContent = function (option) {
        var temp;
        this.sortOptionsInitial.forEach(function (item, index) {
            if (item.option == option) {
                temp = item.id;
            }
        });
        return temp;
    };
    CasePracticePAndOEventComponent.prototype.onQuestionBtnClick = function ($event) {
        var _this = this;
        $event.stopPropagation();
        var that = this;
        // console.log("Question Button Clicked");
        if (this.optionSelectedIndex < 0) {
            return;
        }
        if (this.cardOnSubmit1) {
            return;
        }
        else {
            console.log("submit");
            this.cardOnSubmit1 = true;
        }
        if (this.step == 303) {
            this.urgent2Show = false;
        }
        var pointId;
        if (this.questionIndex == 0) {
            pointId = 20;
        }
        else if (this.questionIndex == 3) {
            pointId = 35;
        }
        else if (this.questionIndex == 4) {
            pointId = 40;
        }
        else if (this.questionIndex == 7) {
            pointId = 55;
        }
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/pnoQuestion/' + this.exerciseId,
            'data': {
                'pno_question_id': this.currentQuestion.id,
                'pno_answer': this.characterArray[this.optionSelectedIndex]
            }
        }).subscribe(function (result) {
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoStorePoint/' + _this.exerciseId,
                'data': {
                    'pno_store_point_id': pointId
                }
            }).subscribe(function (result) {
                _this.oldQuestionIndex = _this.questionIndex;
                _this.oldOptionSelectedIndex = _this.optionSelectedIndex;
                if (_this.questionIndex == 0 || _this.questionIndex == 3 || _this.questionIndex == 4) {
                    var tempQuestion = _this.currentQuestion;
                    var temp_4 = _this.characterArray[_this.optionSelectedIndex];
                    tempQuestion.director_comment.forEach(function (item, index) {
                        if (item.indexOf(temp_4) != -1) {
                            that.analysis = item.split(':')[1];
                            if (that.questionIndex == 0) {
                                that.step = index + 101;
                            }
                            else if (that.questionIndex == 3) {
                                that.step = index + 304;
                                that.currentShortConversationIndex = 0;
                            }
                            else if (that.questionIndex == 4) {
                                that.step = 407;
                            }
                        }
                    });
                    if (_this.questionIndex == 4 && _this.optionSelectedIndex == 1) {
                        /*this.calculationMatrix.pop();*/
                        _this.meSelected = false;
                    }
                    else if (_this.questionIndex == 4 && _this.optionSelectedIndex == 0) {
                        /*this.calculationMatrix.pop();*/
                        _this.meSelected = true;
                    }
                    _this.qCardShow = false;
                    setTimeout(function () {
                        $('#teacherPic').fadeIn(200);
                        that.teacherShow = true;
                        setTimeout(function () {
                            that.clickable = true;
                            that.cardOnSubmit1 = false;
                        }, 1200);
                    }, 1000);
                }
                else if (_this.questionIndex == 7) {
                    var tempQuestion = _this.currentQuestion;
                    _this.qCardShow = false;
                    _this.analysis = tempQuestion.director_comment[0];
                    _this.step = 702;
                    setTimeout(function () {
                        $('#teacherPic').fadeIn(200);
                        that.teacherShow = true;
                        setTimeout(function () {
                            that.clickable = true;
                            that.cardOnSubmit1 = false;
                        }, 1200);
                    }, 1000);
                }
                else {
                    setTimeout(function () {
                        that.clickable = true;
                        that.cardOnSubmit1 = false;
                    }, 1000);
                }
                _this.eventHistory.push({
                    'role': '你的选择',
                    'comment': _this.currentQuestion.options[_this.optionSelectedIndex],
                    'type': 4
                }, {
                    'role': '导师点评',
                    'comment': _this.analysis,
                    'type': 5
                });
            });
        });
    };
    CasePracticePAndOEventComponent.prototype.onSortQuestionBtnClick = function ($event) {
        var _this = this;
        var that = this;
        // console.log("Sort Question Button Clicked");
        // if(!this.isActiveSortBtn){
        //     return;
        // }
        if (this.cardOnSubmit2) {
            return;
        }
        else {
            console.log("submit");
            this.cardOnSubmit2 = true;
        }
        var temp = '';
        var tempQuestion = this.currentQuestion;
        tempQuestion.options.forEach(function (item, index) {
            temp += that.getSortOptionIdByContent(item);
        });
        this.sortQuestionsAnswer = temp;
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/pnoQuestion/' + this.exerciseId,
            'data': {
                'pno_question_id': this.currentQuestion.id,
                'pno_answer': this.sortQuestionsAnswer
            }
        }).subscribe(function (result) {
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoStorePoint/' + _this.exerciseId,
                'data': {
                    'pno_store_point_id': 25
                }
            }).subscribe(function (result) {
                _this.oldQuestionIndex = _this.questionIndex;
                _this.oldOptionSelectedIndex = _this.optionSelectedIndex;
                _this.clickable = false;
                _this.analysis = tempQuestion.director_comment[0];
                _this.qCardShow = false;
                setTimeout(function () {
                    $('#teacherPic').fadeIn(200);
                    that.teacherShow = true;
                    that.step = 104;
                    setTimeout(function () {
                        that.cardOnSubmit2 = false;
                        that.clickable = true;
                    }, 1200);
                }, 1000);
                _this.eventHistory.push({
                    'role': '你的答案',
                    'comment': _this.currentQuestion.options,
                    'type': 4
                }, {
                    'role': '导师点评',
                    'comment': _this.analysis,
                    'type': 5
                });
            });
        });
    };
    CasePracticePAndOEventComponent.prototype.submitCalculation = function ($event) {
        var _this = this;
        $event.stopPropagation();
        var that = this;
        // console.log("Cal Question Button Clicked");
        if (!this.isActiveCalculationBtn) {
            return;
        }
        if (this.cardOnSubmit3) {
            return;
        }
        else {
            console.log("submit");
            this.cardOnSubmit3 = true;
        }
        var temp = {
            '高': {
                '主': {
                    'A': this.calculationMatrix[0].numberArray[0],
                    'B': this.calculationMatrix[0].numberArray[1],
                    'C': 0
                }, '分': {
                    'A': this.calculationMatrix[0].numberArray[2],
                    'B': 0,
                    'C': this.calculationMatrix[0].numberArray[3]
                }
            }, '方': {
                '主': {
                    'A': this.calculationMatrix[1].numberArray[0],
                    'B': this.calculationMatrix[1].numberArray[1],
                    'C': 0
                }, '分': {
                    'A': this.calculationMatrix[1].numberArray[2],
                    'B': 0,
                    'C': this.calculationMatrix[1].numberArray[3]
                }
            }, '秦': {
                '主': {
                    'A': this.calculationMatrix[2].numberArray[0],
                    'B': this.calculationMatrix[2].numberArray[1],
                    'C': 0
                }, '分': {
                    'A': this.calculationMatrix[2].numberArray[2],
                    'B': 0,
                    'C': this.calculationMatrix[2].numberArray[3]
                }
            }
        };
        if (this.meSelected) {
            temp['我'] = {
                '主': {
                    'A': this.calculationMatrix[3].numberArray[0],
                    'B': this.calculationMatrix[3].numberArray[1],
                    'C': 0
                }, '分': {
                    'A': this.calculationMatrix[3].numberArray[2],
                    'B': 0,
                    'C': this.calculationMatrix[3].numberArray[3]
                }
            };
        }
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/pnoQuestion/' + this.exerciseId,
            'data': {
                'pno_question_id': 17,
                'pno_answer': JSON.stringify(temp)
            }
        }).subscribe(function (result) {
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoStorePoint/' + _this.exerciseId,
                'data': {
                    'pno_store_point_id': 45
                }
            }).subscribe(function (result) {
                $('#calculationWrap').fadeOut(200);
                var tempQuestion;
                _this.oldQuestionIndex = _this.questionIndex;
                _this.oldOptionSelectedIndex = _this.optionSelectedIndex;
                if (_this.questionIndex == 4) {
                    _this.questionIndex += 2;
                }
                else {
                    _this.questionIndex++;
                }
                _this.optionSelectedIndex = -1;
                tempQuestion = _this.questions[_this.questionIndex];
                _this.currentQuestion = tempQuestion;
                _this.instruction = tempQuestion.title[0];
                setTimeout(function () {
                    that.instructionShow = true;
                    $('#reviewBtn').fadeIn(200);
                    that.step = 601;
                    setTimeout(function () {
                        that.clickable = true;
                        that.cardOnSubmit3 = false;
                    }, 1000);
                }, 500);
                _this.eventHistory.push({
                    'role': '情节',
                    'comment': that.instruction,
                    'type': 2
                });
            });
        });
    };
    CasePracticePAndOEventComponent.prototype.onOptionMouseDown = function (i, event) {
        if (this.optionClick == true || this.optionOnClick == true) {
            return false;
        }
        // console.log("Option Question Button Clicked");
        var _this = this, pressing = $(event.target).children('.pressing'), // 选项背景进度div
        pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
        pressingWidth = $(event.target).width(), // 选项宽度
        pressingHeight = $(event.target).height(), // 选项高度
        pressingOuterHeight = $(event.target).outerHeight(), // 选项真实高度, 包括margin, padding
        pressingOffset = $(event.target).offset(); // 选项在屏幕的位置
        var tempQuestion = this.currentQuestion;
        // 按选项少于0.45s, 则不响应
        this.optionClick = false;
        this.optionOnClick = true;
        // 设置选项动画参数
        pressingOption.width(pressingWidth);
        pressingOption.height(pressingHeight);
        pressing.width(0);
        pressing.height(pressingOuterHeight),
            pressing.show();
        pressing.offset({ top: pressingOffset.top, left: pressingOffset.left });
        // 选项背景动画
        pressing.animate({
            width: $(event.target)[0].clientWidth
        }, this.type ? 300 : 500, 'linear');
        // 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
        this.optionClickTimeout = setTimeout(function () {
            // 长按响应
            _this.optionClick = true;
            pressing.animate({ width: 0 }, 1);
            pressing.hide();
            // 进入选中按钮动画
            $(event.target).addClass('optionLongPress');
            // 按键之后的动画
            $(event.target).find('.loading').fadeIn(200);
            // 隐藏文字
            // 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
            // console.log(_this.currentQuestion.options[i]);
            // $(event.target).not("").text("");
            $('.optionItem2').not($(event.target)).fadeOut(2500);
            _this.optionSelectedIndex = i;
            var pointId;
            if (_this.questionIndex == 2) {
                pointId = 30;
            }
            else if (_this.questionIndex == 6) {
                pointId = 50;
            }
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoQuestion/' + _this.exerciseId,
                'data': {
                    'pno_question_id': tempQuestion.id,
                    'pno_answer': _this.characterArray[_this.optionSelectedIndex]
                }
            }).subscribe(function (result) {
                _this.apiService.ajax({
                    'type': 'post',
                    'url': '/api/pnoStorePoint/' + _this.exerciseId,
                    'data': {
                        'pno_store_point_id': pointId
                    }
                }).subscribe(function (result) {
                    _this.oldQuestionIndex = _this.questionIndex;
                    _this.oldOptionSelectedIndex = _this.optionSelectedIndex;
                    // 保持选中按钮动画2s, 跳转动画
                    // 移出按钮动画
                    setTimeout(function () {
                        $('#optionsWrap2').fadeOut(10);
                        setTimeout(function () {
                            $(event.target).removeClass('optionLongPress');
                            _this.analysis = tempQuestion.director_comment[0];
                            _this.eventHistory.push({
                                'role': '你的答案',
                                'comment': tempQuestion.options[_this.optionSelectedIndex],
                                'type': 4
                            }, {
                                'role': '导师点评',
                                'comment': _this.analysis,
                                'type': 5
                            });
                            setTimeout(function () {
                                _this.optionClick = false;
                                $('#teacherPic').fadeIn(200);
                                _this.teacherShow = true;
                                if (_this.questionIndex == 2) {
                                    _this.step = 206;
                                }
                                else if (_this.questionIndex == 6) {
                                    _this.step = 604;
                                }
                                setTimeout(function () {
                                    _this.clickable = true;
                                }, 1200);
                            }, 350);
                        }, 200);
                    }, 1800); // end of second setTimeout
                });
            });
        }, 500); // end of first setTimeout
    }; //end of onOptionMouseDown
    CasePracticePAndOEventComponent.prototype.onOptionMouseUp = function (event) {
        var _this = this;
        this.optionOnClick = true;
        setTimeout(function () {
            _this.optionOnClick = false;
        }, 300);
        // 如果已经触发按钮事件, 忽略放松按钮行为
        if (this.optionClick == true) {
            return true;
        }
        var pressing = $(event.target).children('.pressing');
        // 调整宽度为0
        setTimeout(function () {
            clearTimeout(_this.optionClickTimeout);
            pressing.stop().animate({
                width: 0
            }, 300, 'linear');
        }, this.type ? 300 : 0);
    };
    CasePracticePAndOEventComponent.prototype.onOptionClick2 = function ($event, i) {
        var _this = this;
        $event.stopPropagation();
        var that = this;
        if (!this.clickable) {
            return;
        }
        this.clickable = false;
        this.optionSelectedIndex = i;
        var pointId;
        if (this.questionIndex == 2) {
            pointId = 30;
        }
        else if (this.questionIndex == 6) {
            pointId = 50;
        }
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/pnoQuestion/' + this.exerciseId,
            'data': {
                'pno_question_id': this.currentQuestion.id,
                'pno_answer': this.characterArray[this.optionSelectedIndex]
            }
        }).subscribe(function (result) {
            _this.apiService.ajax({
                'type': 'post',
                'url': '/api/pnoStorePoint/' + _this.exerciseId,
                'data': {
                    'pno_store_point_id': pointId
                }
            }).subscribe(function (result) {
                $('#optionsWrap2').fadeOut(200);
                _this.analysis = _this.currentQuestion.director_comment[0];
                setTimeout(function () {
                    that.teacherShow = true;
                    if (that.questionIndex == 2) {
                        that.step = 206;
                    }
                    else if (that.questionIndex == 6) {
                        that.step = 604;
                    }
                    setTimeout(function () {
                        that.clickable = true;
                    }, 1200);
                }, 350);
                _this.eventHistory.push({
                    'role': '你的答案',
                    'comment': _this.currentQuestion.options[_this.optionSelectedIndex],
                    'type': 4
                }, {
                    'role': '导师点评',
                    'comment': _this.analysis,
                    'type': 5
                });
            });
        });
    };
    CasePracticePAndOEventComponent.prototype.reviewConversation = function ($event) {
        $event.stopPropagation();
        this.clickDialogEnable = false;
        $('#shade').fadeIn(50);
        $('#reviewBox').fadeIn();
        $('#closeBtn').fadeIn();
    };
    CasePracticePAndOEventComponent.prototype.reviewTableClick = function ($event, i) {
        $event.stopPropagation();
        this.eventHistory[i].mode = (this.eventHistory[i].mode + 1) % 2;
    };
    CasePracticePAndOEventComponent.prototype.closeTip = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeOut();
        $('#reviewBox').fadeOut();
        /* $('#taskBookBox').fadeOut();*/
        $('#closeBtn').fadeOut();
        // 恢复点击功能
        this.clickDialogEnable = true;
    };
    CasePracticePAndOEventComponent.prototype.onCustomerInfoBtn = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeIn(200);
        $('#customerInfoWrap').fadeIn(200);
        $('#customerInfoCloseBtn').fadeIn(200);
    };
    CasePracticePAndOEventComponent.prototype.onCustomerInfoCloseBtnClick = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeOut(200);
        $('#customerInfoWrap').fadeOut(200);
        $('#customerInfoCloseBtn').fadeOut(200);
    };
    CasePracticePAndOEventComponent.prototype.onSquareClick = function ($event, i, j) {
        $event.stopPropagation();
        var _this = this;
        if (this.customerArray[j] <= 0) {
            return;
        }
        /*if((i==0||i==1)&&(j==0||j==2)){
            return;
        }
        if(i==0&&j==1){
            return;
        }*/
        var currentTime = 0;
        this.calculationMatrix[i].numberArray.forEach(function (item, index) {
            currentTime += item * _this.timeArray[index];
        });
        if (currentTime + this.timeArray[j] > 240) {
            return;
        }
        this.calculationMatrix[i].numberArray[j]++;
        this.customerArray[j]--;
        this.setCalculationSubmitBtnStatus();
    };
    CasePracticePAndOEventComponent.prototype.onMinusBtnClick = function ($event, i, j) {
        $event.stopPropagation();
        if (this.calculationMatrix[i].numberArray[j] <= 0) {
            return;
        }
        this.calculationMatrix[i].numberArray[j]--;
        this.customerArray[j]++;
        this.setCalculationSubmitBtnStatus();
    };
    CasePracticePAndOEventComponent.prototype.setCalculationSubmitBtnStatus = function () {
        var temp = false;
        var _this = this;
        this.calculationMatrix.forEach(function (item, index) {
            item.numberArray.forEach(function (subItem, index) {
                if (subItem > 0) {
                    temp = true;
                }
            });
        });
        this.isActiveCalculationBtn = temp;
    };
    CasePracticePAndOEventComponent.prototype.linkToReport = function () {
        var _this = this;
        var exerciseMetaId = $('#exerciseMetaId').val();
        console.log(localStorage.getItem('learningPathMetaId'));
        this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 2, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
            console.log(result);
        });
        console.log(exerciseMetaId);
        this.commonService.sendPostMessage(2, 'isPractice' + 'Complete');
        var type = null;
        this.route.queryParams.subscribe(function (queryParams) {
            type = queryParams['type'];
        });
        // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/pnoCalKaPoint/' + this.exerciseId
        }).subscribe(function (result) {
            _this.apiService.finishExercise("" + _this.exerciseId + "").subscribe(function (practice) {
                _this.apiService.getKasInfos(_this.exerciseId, _this.practiceId).subscribe(function (result) {
                    console.log(111111, result);
                    if (result) {
                        _this.apiService.getLevelInfo(result.reports[0]);
                    }
                });
                var link = ['case-practice-report-new', _this.practiceId, _this.exerciseId, _this.learningPathId];
                if (type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            });
        });
    };
    CasePracticePAndOEventComponent.prototype.setHeight = function () {
        var that = this;
        $(document).ready(function () {
            var temp = $(window).height() - 4 * that.commonService.rootFontSize();
            $('#calculationTopPic').height(temp);
        });
    };
    CasePracticePAndOEventComponent.prototype.showQFDialog = function () {
        $('#dialogueBox4').fadeIn(200);
        $('#qf2').fadeIn(200);
    };
    CasePracticePAndOEventComponent.prototype.hideQFDialog = function () {
        $('#dialogueBox4').fadeOut(200);
        $("#qf2").fadeOut(200);
    };
    CasePracticePAndOEventComponent.prototype.hideTip2 = function () {
        $("#shade2").fadeOut();
        $('#tip2').fadeOut();
    };
    CasePracticePAndOEventComponent.prototype.try = function () {
        $('body').css("height", "100%");
        var link = ['form', '3'];
        this.router.navigate(link);
        // if(this.userType === '3'){
        //   window.sessionStorage.setItem('submitType','1');
        //
        // }else{
        //   let link = ['success'];
        //   this.router.navigate(link);
        // }
    };
    CasePracticePAndOEventComponent.prototype.returnList = function () {
        // let link = window.location.href+'#caseId='+Math.random();
        // console.log(link);
        // window.location.href =link;
        location.reload();
    };
    return CasePracticePAndOEventComponent;
}());
export { CasePracticePAndOEventComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-p-and-o-event/case-practice-p-and-o-event.component.ts.pre-build-optimizer.js